export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-mic-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-ghost-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
  { slug: 'duanju', name: '短剧', icon: 'ri-smartphone-line' },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line' },
];